import { Distribute, Text, TextButton } from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { track } from 'utilities/analytics';
import * as intercom from 'utilities/intercom';

import { dismissElementHandler } from '../../utilities';
import { DASHBOARDING_ONBOARDING_STARRED_CTA_CLICKED } from '../../../../../constants/events';
import { useGetChecklistHasViewedVideos } from '../../../../../hooks/getStartedChecklist';
import { useGetSelectedWorkspace } from '../../../../../hooks/workspace';
import { ORG_ROLE_VIEWER } from '../../../../../../../shared/constants/organizationRoles';
import {
  WORKSPACE_ELEMENT_DISMISSED,
  WORKSPACE_VIEWER_STAR_BUTTON_TOOLTIP,
} from '../../../../../../../shared/constants/workspaceOnboarding';

import styles from './styles.module.less';

const PRODUCT_TOUR_ID = 136432;
const PRODUCT_TOUR_LINK = `https://www.loom.com/team-videos?product_tour_id=${PRODUCT_TOUR_ID}`;

const ViewerOnboardingStarTooltip = () => {
  const dispatch = useDispatch();
  const selectedWorkspace = useGetSelectedWorkspace();
  const hasViewedVideos = useGetChecklistHasViewedVideos();
  const isViewer = selectedWorkspace?.memberRole === ORG_ROLE_VIEWER;
  const isDismissed =
    selectedWorkspace?.onboarding?.[WORKSPACE_VIEWER_STAR_BUTTON_TOOLTIP] ===
    WORKSPACE_ELEMENT_DISMISSED;

  if (isDismissed || !isViewer || !hasViewedVideos) {
    return null;
  }

  return (
    <div className={classnames(styles.tooltipContainer, 'theme-dark')}>
      <Text color="body">
        Star important videos and folders for quick access.
      </Text>
      <Distribute isSpread className={styles.tooltipActions}>
        <TextButton
          size="small"
          className={styles.tooltipActionShowMeHow}
          onClick={() => {
            const tourIsOnSamePage = PRODUCT_TOUR_LINK.includes(
              window.location.pathname
            );

            track(DASHBOARDING_ONBOARDING_STARRED_CTA_CLICKED, {
              tourId: PRODUCT_TOUR_ID,
            });

            if (!tourIsOnSamePage) {
              window.location.href = PRODUCT_TOUR_LINK;
            } else {
              intercom.startTour(PRODUCT_TOUR_ID);
            }
          }}
        >
          Show me how
        </TextButton>
        <TextButton
          size="small"
          onClick={() =>
            dismissElementHandler(
              dispatch,
              WORKSPACE_VIEWER_STAR_BUTTON_TOOLTIP,
              selectedWorkspace.id
            )
          }
        >
          Dismiss
        </TextButton>
      </Distribute>
    </div>
  );
};

export default ViewerOnboardingStarTooltip;
